import React, { useCallback, useEffect } from 'react';
import './filerepo-link.css';
import { useLazyQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { toastFailure } from 'motion-components';

/*
use as:
import { FileRepoLink } from 'components/common/filerepo-link';
<FileRepoLink fileId={row.original?.invoiceFile?.id} fileName={row.original?.invoiceFile?.fileName} />
*/

export const FileRepoLink = ({ fileId, fileName }) => {
  const gqlGetFilesRepositoryFileUrlById = gql`
    query getFilesrepositoryFileUrlById($id: Int) {
      getFilesrepositoryFileUrlById(id: $id)
    }
  `;

  const [getFileUrl, { data: dataFileUrl }] = useLazyQuery(gqlGetFilesRepositoryFileUrlById, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => console.log('onCompleted', data),
  });

  useEffect(() => {
    if (!!dataFileUrl) {
      const fileUrl = dataFileUrl?.getFilesrepositoryFileUrlById ?? undefined;
      console.log('fileUrl', fileUrl);
      // Το query string είναι το S3 signature· χωρίς αυτό το bucket είναι private και βγάζει Access Denied
      if (fileUrl) {
        window.open(fileUrl);
        // window.open(fileUrl, '_blank').focus();
      } else {
        toastFailure('Πρόβλημα Στο Κατέβασμα του Αρχείου');
      }
    }
  }, [dataFileUrl]);

  const handleFileOpen = useCallback(
    (id) => {
      console.log('handleFileOpen');
      getFileUrl({ variables: { id } });
    },
    [getFileUrl],
  );

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a onClick={() => handleFileOpen(fileId)} style={{ cursor: 'pointer', color: '#4987b7' }}>
      {fileName}
    </a>
  );
};
